import React from 'react';

export const PlusIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_937_1971)">
      <mask
        id="mask0_937_1971"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect y="6.10352e-05" width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_937_1971)">
        <path
          d="M8.25 10.5001H9.75V8.25006H12V6.75006H9.75V4.50006H8.25V6.75006H6V8.25006H8.25V10.5001ZM9 16.5001C6.9875 14.7876 5.48438 13.1969 4.49063 11.7282C3.49688 10.2594 3 8.90006 3 7.65006C3 5.77506 3.60312 4.28131 4.80938 3.16881C6.01563 2.05631 7.4125 1.50006 9 1.50006C10.5875 1.50006 11.9844 2.05631 13.1906 3.16881C14.3969 4.28131 15 5.77506 15 7.65006C15 8.90006 14.5031 10.2594 13.5094 11.7282C12.5156 13.1969 11.0125 14.7876 9 16.5001Z"
          fill="#E4E4E4"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_937_1971">
        <rect width="18" height="18" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const tempDefaultErr = {
  isName: false,
  isDate: false,
  isLink: false,
  isLatitude: false,
  isLongitude: false,
  isDescription: false
};

export const tempDataDefault = {
  name: '',
  date: '',
  link: '',
  latitude: '',
  longitude: '',
  description: '',
  banner: null,
  bannerUrl: ''
};

/**
 * Banner upload limits. These mirror the global-event service's own checks on
 * POST /dum/event and POST /dum/event/{dumId}; the server stays the control,
 * these exist so the user is told before a 5 MB upload is spent.
 */
export const BANNER_MAX_SIZE_BYTES = 5242880;

export const BANNER_ACCEPTED_MIME_TYPES = [
  'image/jpeg',
  'image/png',
  'image/webp'
];

export const BANNER_ACCEPT_ATTRIBUTE = BANNER_ACCEPTED_MIME_TYPES.join(',');

export const BannerText = {
  label: 'Event Banner (Optional)',
  placeholder: 'No file selected',
  action: 'Choose Image',
  help: 'JPG, PNG or WEBP. Maximum size 5 MB.',
  errorSize: 'Banner is too large. Maximum allowed size is 5 MB.',
  errorFormat:
    'Invalid banner format. Only JPG, PNG and WEBP images are allowed.'
};

/**
 * Optional external video link for the event, sent as the `banner_url` part of
 * the same multipart submission as `banner`. It is a separate field from the
 * required "Historical Event Link" (the source reference) on purpose: this one
 * is the media the portal opens, and Rio asked for a YouTube example inline.
 *
 * There is deliberately no `help` string: JUR-794 removed the descriptive line
 * under the field, so the label and the YouTube placeholder carry the meaning.
 */
export const BannerUrlText = {
  label: 'Event Video Link (Optional)',
  placeholder: 'https://www.youtube.com/watch?v=...',
  errorFormat:
    'Enter a full video URL starting with http:// or https:// , for example https://www.youtube.com/watch?v=dQw4w9WgXcQ'
};

export const PlaceholderText = {
  name: 'Black Death',
  date: '12 October 1346',
  link: 'https://en.wikipedia.org/wiki/Black_Death',
  description:
    'The Black Death (also known as the Pestilence, the Great Mortality or the Plague) was a bubonic plague pandemic occurring in Western Eurasia and North Africa from 1346 to 1353. It is the most fatal pandemic recorded in human history, causing the deaths of 75–200 million people'
};
